export default "__VITE_ASSET__CJxRQTKb__"